export var BEFORE_INPUT = 'onBeforeInput';
export var BLUR = 'onBlur';
export var CLICK = 'onClick';
export var CONTEXT_MENU = 'onContextMenu';
export var COMPOSITION_END = 'onCompositionEnd';
export var COMPOSITION_START = 'onCompositionStart';
export var COPY = 'onCopy';
export var CUT = 'onCut';
export var DRAG_END = 'onDragEnd';
export var DRAG_ENTER = 'onDragEnter';
export var DRAG_EXIT = 'onDragExit';
export var DRAG_LEAVE = 'onDragLeave';
export var DRAG_OVER = 'onDragOver';
export var DRAG_START = 'onDragStart';
export var DROP = 'onDrop';
export var INPUT = 'onInput';
export var FOCUS = 'onFocus';
export var KEY_DOWN = 'onKeyDown';
export var KEY_UP = 'onKeyUp';
export var MOUSE_DOWN = 'onMouseDown';
export var MOUSE_UP = 'onMouseUp';
export var PASTE = 'onPaste';
export var SELECT = 'onSelect';
export default [BEFORE_INPUT, BLUR, CLICK, CONTEXT_MENU, COMPOSITION_END, COMPOSITION_START, COPY, CUT, DRAG_END, DRAG_ENTER, DRAG_EXIT, DRAG_LEAVE, DRAG_OVER, DRAG_START, DROP, INPUT, FOCUS, KEY_DOWN, KEY_UP, MOUSE_DOWN, MOUSE_UP, PASTE, SELECT];